// *********************************************
//     Main JavaScript File 🚩
// ****************************

// Add your JavaScript code here
// This file will be minified to all.min.js

window.initMap = function () {
  console.log("Google Maps API initialized.");
};
if (typeof jQuery !== "undefined") {
  if (typeof jQuery.fn.slick === 'undefined') {
    window.slickQueue = [];
    jQuery.fn.slick = function() {
      if (arguments.length > 0 && arguments[0] === 'unslick') {
        this.removeClass('slick-initialized');
        return this;
      }
      this.addClass('slick-initialized');
      window.slickQueue.push({el: this, args: arguments});
      return this;
    };
  }

  jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (options.type && options.type.toLowerCase() === "post") {
      var csrfName = jQuery('meta[name="csrf-name"]').attr("content");
      var csrfHash = jQuery('meta[name="csrf-token"]').attr("content");

      if (csrfName && csrfHash) {
        if (typeof options.data === "string") {
          options.data += (options.data.length > 0 ? "&" : "") + encodeURIComponent(csrfName) + "=" + encodeURIComponent(csrfHash);
        } else if (typeof options.data === "object" && !(options.data instanceof FormData)) {
          options.data = options.data || {};
          options.data[csrfName] = csrfHash;
        }
      }
    }
  });
}

// Global ITI Safeguard: Intercept focus to prevent version collisions
(function () {
  function interceptFocus(e) {
    if (
      e.target &&
      e.target.classList &&
      e.target.classList.contains("phoneVal")
    ) {
      if (
        e.target.iti ||
        (window.intlTelInput &&
          window.intlTelInput.version &&
          window.intlTelInput.version.startsWith("25"))
      ) {
        // Version 25 is active or element is already initialized, stop footer (v19) listener
        e.stopImmediatePropagation();
      }
    }
  }
  document.addEventListener("focus", interceptFocus, true);

  // Removed broad restrictions on copy/paste/cut to improve accessibility and best practices
})();

(function () {
  function normalizeCountryName(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ");
  }

  function syncCountryFieldFromPhoneInput(phoneInput) {
    if (!phoneInput || !phoneInput.iti) return;

    const form = phoneInput.closest("form");
    const selectedCountry = phoneInput.iti.getSelectedCountryData();
    if (!form || !selectedCountry || !selectedCountry.dialCode) return;

    const countryVal = selectedCountry.dialCode;
    const hiddenCountryInput = form.querySelector(
      'input[type="hidden"][name="country"], input[type="hidden"].country-selected, input[type="hidden"]#country-selected',
    );

    if (hiddenCountryInput) {
      hiddenCountryInput.value = countryVal;
    }

    const countrySelect = form.querySelector('select[name="country"]');
    if (countrySelect) {
      const targetName = normalizeCountryName(countryName);
      const matchingOption = Array.from(countrySelect.options).find(
        (option) => {
          const optionText = normalizeCountryName(option.text);
          return (
            optionText === targetName ||
            optionText.endsWith(" " + targetName) ||
            optionText.includes(targetName)
          );
        },
      );

      if (matchingOption) {
        countrySelect.value = matchingOption.value;
      }
    }
  }

  window.syncCountryFieldFromPhoneInput = syncCountryFieldFromPhoneInput;
})();

(function () {
  function getSubmitControl(form, submitter) {
    if (
      submitter &&
      (submitter.matches('button[type="submit"]') ||
        submitter.matches('input[type="submit"]'))
    ) {
      return submitter;
    }

    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function setFormSubmittingState(form, submitter) {
    if (!form) return null;

    const submitControl = getSubmitControl(form, submitter);
    if (!submitControl || submitControl.dataset.submitting === "true") {
      return submitControl;
    }

    const loadingText = submitControl.dataset.loadingText || "Submitting...";
    submitControl.dataset.submitting = "true";
    submitControl.disabled = true;
    submitControl.setAttribute("aria-busy", "true");
    submitControl.classList.add("is-submitting");
    form.dataset.submitting = "true";

    if (submitControl.tagName === "BUTTON") {
      if (!submitControl.dataset.originalHtml) {
        submitControl.dataset.originalHtml = submitControl.innerHTML;
      }
      submitControl.innerHTML =
        '<span class="btn-loading-spinner" aria-hidden="true"></span><span class="btn-loading-text">' +
        loadingText +
        "</span>";
    } else {
      if (!submitControl.dataset.originalValue) {
        submitControl.dataset.originalValue = submitControl.value;
      }
      submitControl.value = loadingText;
    }

    return submitControl;
  }

  function resetFormSubmittingState(form, submitter) {
    if (!form) return;

    const submitControl =
      getSubmitControl(form, submitter) ||
      form.querySelector('[data-submitting="true"]');

    if (!submitControl) return;

    submitControl.disabled = false;
    submitControl.removeAttribute("aria-busy");
    submitControl.classList.remove("is-submitting");
    submitControl.dataset.submitting = "false";
    delete form.dataset.submitting;

    if (
      submitControl.tagName === "BUTTON" &&
      typeof submitControl.dataset.originalHtml !== "undefined"
    ) {
      submitControl.innerHTML = submitControl.dataset.originalHtml;
    }

    if (
      submitControl.tagName === "INPUT" &&
      typeof submitControl.dataset.originalValue !== "undefined"
    ) {
      submitControl.value = submitControl.dataset.originalValue;
    }
  }

  function resetAllForms() {
    document.querySelectorAll("form").forEach(function (form) {
      // form.reset();
      resetFormSubmittingState(form);
    });
  }

  window.setFormSubmittingState = setFormSubmittingState;
  window.resetFormSubmittingState = resetFormSubmittingState;
  window.resetAllForms = resetAllForms;

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    window.setTimeout(function () {
      if (event.defaultPrevented || form.dataset.submitting === "true") return;
      setFormSubmittingState(form, event.submitter);
    }, 0);
  });

  window.addEventListener("pageshow", function (event) {
    const navigationEntries =
      window.performance &&
        typeof window.performance.getEntriesByType === "function"
        ? window.performance.getEntriesByType("navigation")
        : [];
    const isBackForwardNavigation =
      navigationEntries.length > 0 &&
      navigationEntries[0].type === "back_forward";

    // If persisted is true, the page is being loaded from the bfcache (Back-Forward Cache)
    // or if it's a back/forward navigation, we ensure all forms are reset and fresh.
    if (event.persisted || isBackForwardNavigation) {
      resetAllForms();
      window.location.reload();
    }

    document
      .querySelectorAll('form[data-submitting="true"]')
      .forEach(function (form) {
        resetFormSubmittingState(form);
      });
  });
})();

$(document).ready(function () {
  // Common Validations: Restrict copy-paste and trim trailing spaces on blur
  $(".career-custom-form input, .career-custom-form textarea").on(
    "copy paste",
    function (e) {
      if ($(this).attr("type") !== "file") {
        e.preventDefault();
      }
    },
  );

  $(".career-custom-form input, .career-custom-form textarea").on(
    "blur",
    function () {
      if ($(this).attr("type") !== "file") {
        $(this).val($(this).val().replace(/\s+$/, ""));
        $(this).trigger("keyup");
      }
    },
  );

  // Restrict Input: Allow only alphabets and spaces
  $(document).on("input", ".alpha-only", function () {
    this.value = this.value.replace(/[^a-zA-Z\s]/g, "");
  });

  // Restrict Phone Number: Allow only numbers and plus (No spaces, dashes, or parentheses)
  function restrictPhoneInput(el) {
    el.value = el.value.replace(/[^0-9+]/g, "");
    if (el.value.length > 15) {
      el.value = el.value.substring(0, 15);
    }
  }

  $(document).on("input keyup paste", ".phoneVal", function () {
    restrictPhoneInput(this);
  });

  $(document).on("keydown", ".phoneVal", function (e) {
    if (e.key === " " || e.keyCode === 32) {
      e.preventDefault();
      return false;
    }
  });

  // Restrict Full Name and Designation in Request Form (Only Alphabets and Spaces, No Leading Space)
  $(document).on(
    "input",
    ".request-form__main [name='fname'], .request-form__main [name='name'], .request-form__main [name='designation']",
    function () {
      this.value = this.value.replace(/[^a-zA-Z\s]/g, "").replace(/^\s+/, "");
      // Limit to 100 chars
      if (($(this).attr("name") === "fname" || $(this).attr("name") === "name") && this.value.length > 100) {
        this.value = this.value.substring(0, 100);
      }
    },
  );

  // Restrict spaces in Email
  $(document).on("input", ".request-form__main [name='email']", function () {
    this.value = this.value.replace(/\s/g, "");
  });

  // Document ready code here
  // --- Slider Logic ---
  const slides = $(".hero-bg-slider .slide");
  const totalSlides = slides.length;
  let currentIndex = 0;
  const intervalTime = 5000; // 5 Seconds

  function runSlider() {
    // Remove active class from current slide
    $(slides[currentIndex]).removeClass("active");

    // Calculate next index
    currentIndex = (currentIndex + 1) % totalSlides;

    // Add active class to next slide
    $(slides[currentIndex]).addClass("active");
  }

  // Start Auto Slider
  setInterval(runSlider, intervalTime);

  // if not a home page then need to add sticky class to header
  var path = window.location.pathname;
  var isHome =
    path === "/" ||
    path === "" ||
    path.endsWith("/index.php") ||
    path.includes("/home");

  // other pages → add sticky immediately
  if (!isHome) {
    $(".main-header").addClass("sticky");
  }

  // --- Sticky Header Logic (Throttled) ---
  let scrollTicking = false;
  window.addEventListener(
    "scroll",
    function () {
      if (!scrollTicking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY || window.pageYOffset;
          if (scrollY > 0) {
            $(".main-header").addClass("sticky");
          } else {
            if (isHome) {
              $(".main-header").removeClass("sticky");
            }
          }

          // Add scrolled class for extra reliability on search box visibility
          if (scrollY > 100) {
            $(".main-header").addClass("scrolled");
          } else {
            $(".main-header").removeClass("scrolled");
          }

          scrollTicking = false;
        });
        scrollTicking = true;
      }
    },
    { passive: true },
  );

  // --- Cookie Banner Close Logic ---
  $(".close-cookie").on("click", function () {
    $(this).closest(".cookie-box").fadeOut();
  });

  // --- Reports Sidebar Toggle ---
  // --- Unified Drawer Toggle ---
  $(".drawer-trigger").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var targetId = $(this).data("target");

    // Hide all sections first, then show target
    $(".drawer-section").hide();
    $("#" + targetId).show();

    // Reset any active sub-sidebars
    $(".sidebar-submenu").removeClass("active");

    $(".report-sidebar").addClass("active");

    // Check if overlay exists, if not create
    if ($(".sidebar-overlay").length === 0) {
      $("body").append('<div class="sidebar-overlay"></div>');
      setTimeout(function () {
        $(".sidebar-overlay").addClass("active");
      }, 10);
    } else {
      $(".sidebar-overlay").addClass("active");
    }
  });

  // Trending Reports Tab Switching
  $(".trending-reports__tab").on("click", function () {
    var tabName = $(this).data("tab");

    // Remove active class from all tabs and panels
    $(".trending-reports__tab").removeClass("active");
    $(".trending-reports__tab-panel").removeClass("active");

    // Add active class to clicked tab and corresponding panel
    $(this).addClass("active");
    $('.trending-reports__tab-panel[data-panel="' + tabName + '"]').addClass(
      "active",
    );
  });


  // Close Sidebar Action
  function closeSidebar() {
    $(".report-sidebar").removeClass("active");
    $(".sidebar-submenu").removeClass("active");
    $(".sidebar-menu li").removeClass("active"); // Clear active LIs on close
    $(".sidebar-overlay").removeClass("active");
    setTimeout(function () {
      $(".sidebar-overlay").remove();
    }, 300);
  }

  $(document).on("click", ".close-sidebar", closeSidebar);
  $(document).on("click", ".sidebar-overlay", closeSidebar);

  // Collapse sidebar submenus — use event delegation so AJAX-injected items are also covered
  $(document).on("click", ".sidebar-menu li.has-child > a", function (e) {
    var $this = $(this);

    // Let the vanilla JS unified drawer logic handle mobile drill-downs
    if (window.innerWidth < 992 && $this.next(".sidebar-submenu").length > 0) {
      return; // Skip jQuery toggle, vanilla JS will physically move and animate the submenu
    }

    // Desktop Behavior (Side Panel)
    if (
      window.matchMedia("(min-width: 992px)").matches &&
      $this.closest("#drawer-reports").length > 0
    ) {
      e.preventDefault();
      e.stopPropagation();

      var $submenu = $this.next(".sidebar-submenu");
      var isActive = $submenu.hasClass("active");

      // Close all other submenus in the reports drawer
      $("#drawer-reports .sidebar-submenu").removeClass("active");
      $("#drawer-reports .sidebar-menu li").removeClass("active");

      if (!isActive) {
        $submenu.addClass("active");
        $this.parent("li").addClass("active");
      }
      return;
    }

    if (!$this.attr("href").includes("industries/")) {
      // e.preventDefault();
    }
    // Optional: Toggle submenu
    $this.next(".sidebar-submenu").slideToggle();
    $this.find("i").toggleClass("fa-chevron-down fa-chevron-left");
  });

  // --- Testimonials Slider ---
  $(".testimonials-slider").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: 'ondemand',
    // Custom arrows are styled via CSS on slick-prev/slick-next generated by slick or we can use appendArrows
    // If we rely on default generated ones, we just style them.
    prevArrow:
      '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next" aria-label="Next"></button>',
  });

  if ($(window).width() < 600) {
    $(".slider-mobile").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      arrows: false,
      dots: true,
    });
  }

  // --- Display Uploaded File Name ---
  $("#resume_file").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    if (fileName) {
      $(this).siblings("label").find(".file-placeholder").text(fileName);
    } else {
      $(this).siblings("label").find(".file-placeholder").text("Choose file*");
      $(this).siblings("label").removeAttr("style");
    }
  });

  // --- UTM Parameters handled server-side via UtmHook.php and render_utm_hidden_fields() ---
  // --- Intelligence Mobile Slider ----
  function initIntelligenceSlider() {
    if (window.innerWidth <= 600) {
      if (!$(".intelligence__row").hasClass("slick-initialized")) {
        $(".intelligence__row").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
        });
      }
    } else {
      if ($(".intelligence__row").hasClass("slick-initialized")) {
        $(".intelligence__row").slick("unslick");
      }
    }
  }

  initIntelligenceSlider();
  $(window).on("resize", initIntelligenceSlider);

  function teamMobileSlider() {
    if ($(window).width() <= 600) {
      if (!$(".team-members").hasClass("slick-initialized")) {
        $(".team-members").slick({
          slidesToShow: 1, // show slight next card
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false,
          adaptiveHeight: true,
        });
      }
    } else {
      if ($(".team-members").hasClass("slick-initialized")) {
        $(".team-members").slick("unslick");
      }
    }
  }

  teamMobileSlider();
  $(window).on("resize", teamMobileSlider);

  // --- Industries Mobile Drawer Toggle ---
  $(document).on("click", "#mobileSidebarToggle", function () {
    $(this).fadeOut(200, function () {
      $(".listing-sidebar").slideDown(400);
    });
  });

  $(document).on("click", "#closeMobileSidebar", function () {
    $(".listing-sidebar").slideUp(400, function () {
      $("#mobileSidebarToggle").fadeIn(200);
    });
  });

  // --- Industry Sidebar Accordion Toggle ---
  function initAccordionIcons() {
    $(".industry-accordion .accordion-item").each(function () {
      var $icon = $(this).find(".icon-chevron i");
      if ($(this).hasClass("active")) {
        $icon.removeClass("fa-chevron-down").addClass("fa-chevron-up");
      } else {
        $icon.removeClass("fa-chevron-up").addClass("fa-chevron-down");
      }
    });
  }
  initAccordionIcons();

  $(".industry-accordion .accordion-link").on("click", function (e) {
    // If it has submenus, we might want to toggle instead of navigate on mobile
    // But for now, let's just make the chevron a reliable toggle and clicking the text also toggles if it's already active or we are on mobile.

    var $item = $(this).closest(".accordion-item");
    if ($(e.target).closest(".icon-chevron").length) {
      e.preventDefault();
      e.stopPropagation();
      $item.toggleClass("active");

      // Toggle Font-Awesome icons
      var $icon = $(this).find(".icon-chevron i");
      if ($item.hasClass("active")) {
        $icon.removeClass("fa-chevron-down").addClass("fa-chevron-up");
      } else {
        $icon.removeClass("fa-chevron-up").addClass("fa-chevron-down");
      }
    }
  });

  // --- Industries AJAX Pagination ---
  $(document).on("click", ".industriesPaginationClick", function () {
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var category = $this.data("category");
    var subcategory = $this.data("subcategory");
    var search = $this.data("search");
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "industry_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        category: category,
        subcategory: subcategory,
        search: search,
        _: new Date().getTime(), // Bypass Cloudflare/Browser cache
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        } else {
          $(".cate-details").html(response);
        }
      },
      error: function (xhr, error, thrown) {
        console.log("Ajax error:", error, thrown);
      },
    });
  });

  // --- Published Report List AJAX Pagination ---
  $(document).on("click", ".publishReportPaginationClick", function () {
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "publish_report_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        _: new Date().getTime(),
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        } else {
          $(".cate-details").html(response);
        }
      },
      error: function (xhr, error, thrown) {
        console.log("Ajax error:", error, thrown);
      },
    });
  });

  // --- Search Results AJAX Pagination ---
  $(document).on("click", ".searchResultsPaginationClick", function () {
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var search = $this.data("search");
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "search_result_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        search: search,
        _: new Date().getTime(),
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        }
      },
      error: function (xhr, error, thrown) {
        console.log("Ajax error:", error, thrown);
      },
    });
  });

  // --- Custom Modal logic (Replacement for Bootstrap) ---
  $(document).on("click", '[data-toggle="modal"]', function (e) {
    e.preventDefault();
    var target = $(this).data("target") || $(this).attr("href");
    $(target).addClass("show").show();
    $("body").addClass("modal-open");
  });

  $(document).on("click", '[data-dismiss="modal"]', function () {
    $(this).closest(".modal").removeClass("show").hide();
    $("body").removeClass("modal-open");
    console.log("SH custom modal closed, hiding error messages");
    $(".error-msg").hide();
  });

  // Close modal when clicking outside
  $(window).on("click", function (e) {
    if ($(e.target).hasClass("modal")) {
      $(".modal").removeClass("show").hide();
      $("body").removeClass("modal-open");
      console.log(
        "SH custom modal closed by clicking outside, hiding error messages",
      );
      $(".error-msg").hide();
    }
  });

  // --- Team Profile Modal ---
  (function initTeamProfileModal() {
    var teamProfileModal = document.getElementById("teamProfileModal");

    if (!teamProfileModal) {
      return;
    }

    var modalCloseButton = teamProfileModal.querySelector(
      ".pmr-custom-modal__close",
    );
    var modalName = teamProfileModal.querySelector(".profile-card__name");
    var modalTitle = teamProfileModal.querySelector(".profile-card__title");
    var modalDescription = teamProfileModal.querySelector(
      ".profile-card__description",
    );
    var modalImage = teamProfileModal.querySelector(".profile-card__image");
    var modalLink = teamProfileModal.querySelector(".img-box a");

    function getCardProfileData(trigger) {
      var triggerImage = trigger.querySelector(".img-box img");
      var triggerName = trigger.querySelector(".team-card__name");
      var triggerTitle = trigger.querySelector("p");
      var profileDescription = trigger.dataset.profileDescription || "";
      var profileName =
        trigger.dataset.profileName ||
        (triggerName ? triggerName.textContent.trim() : "");
      var profileTitle =
        trigger.dataset.profileTitle ||
        (triggerTitle ? triggerTitle.textContent.trim() : "");
      var profileImage =
        trigger.dataset.profileImage ||
        (triggerImage ? triggerImage.getAttribute("src") : "");
      var profileImageAlt =
        profileName || (triggerImage ? triggerImage.getAttribute("alt") : "");
      var profileUrl = trigger.dataset.profileUrl || "";

      return {
        image: profileImage,
        imageAlt: profileImageAlt,
        name: profileName,
        title: profileTitle,
        description: profileDescription.trim(),
        url: profileUrl,
      };
    }

    function openTeamProfileModal(trigger) {
      var profile = getCardProfileData(trigger);

      if (modalImage) {
        if (profile.image) {
          modalImage.setAttribute("src", profile.image);
        }
        modalImage.setAttribute("alt", profile.imageAlt || "");
      }

      if (modalName) {
        modalName.textContent = profile.name;
      }

      if (modalTitle) {
        modalTitle.textContent = profile.title;
      }

      if (modalDescription) {
        modalDescription.textContent = profile.description;
        modalDescription.hidden = profile.description.length === 0;
      }

      if (modalLink) {
        if (profile.url) {
          modalLink.setAttribute("href", profile.url);
          modalLink.style.display = "";
        } else {
          modalLink.setAttribute("href", "");
          modalLink.style.display = "none";
        }
      }

      teamProfileModal.classList.add("active");
      teamProfileModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    function closeTeamProfileModal() {
      teamProfileModal.classList.remove("active");
      teamProfileModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest(".team-members .team-card__trigger");
      if (trigger) {
        event.preventDefault();
        openTeamProfileModal(trigger);
        return;
      }
    });

    if (modalCloseButton) {
      modalCloseButton.addEventListener("click", closeTeamProfileModal);
    }

    teamProfileModal.addEventListener("click", function (event) {
      if (event.target === teamProfileModal) {
        closeTeamProfileModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        teamProfileModal.classList.contains("active")
      ) {
        closeTeamProfileModal();
      }
    });
  })();

  // --- Custom Tab logic (Replacement for Bootstrap) ---
  $(document).on("click", '[data-toggle="tab"]', function (e) {
    e.preventDefault();
    var $this = $(this);
    var target = $this.attr("href") || $this.data("target");

    // Update Nav
    $this.closest(".nav-tabs").find(".nav-link").removeClass("active");
    $this.addClass("active");

    // Update Content
    var $tabContent = $(target).closest(".tab-content");
    $tabContent.find(".tab-pane").removeClass("show active").hide();
    $(target).addClass("show active").fadeIn();
  });

  // --- Mobile Search Toggle ---
  $(document).on("click", ".search-box .search-btn", function (e) {
    if (window.innerWidth <= 600) {
      var $input = $(this).siblings("input");
      if ($input.val() === "") {
        e.preventDefault();
        $input.toggleClass("active").focus();
        $input.slideToggle(200);
      }
    }
  });

  // --- intl-tel-input Initialization (JS only) ---
  // --- intl-tel-input Initialization (Robust Migration Logic) ---
  function initITL() {
    if (typeof window.intlTelInput === "undefined") return;

    document.querySelectorAll(".phoneVal").forEach((el) => {
      if (el.dataset.iti_bound || el.closest(".iti")) return;
      el.dataset.iti_bound = "true";

      /* Disabled ITI as per requirement
      const iti = window.intlTelInput(el, {
        initialCountry: "in",
        separateDialCode: true,
        showFlags: true,
        showSelectedDialCode: true,
        strictMode: false,
        useFullscreenPopup: false,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js",
      });

      // Handle country sync if global sync function exists
      el.addEventListener("countrychange", () => {
        if (window.syncCountryFieldFromPhoneInput) window.syncCountryFieldFromPhoneInput(el);
      });
      */

      // Strictly block spaces and limit 15 digits
      el.addEventListener("keydown", function (e) {
        if (e.key === " " || e.keyCode === 32) {
          e.preventDefault();
        }
      });
      el.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9+]/g, "");
        if (this.value.length > 15) {
          this.value = this.value.substring(0, 15);
        }
      });
    });
  }

  // Robust Automation: Watch for any NEW phone fields (modals, etc.)
  const itiObserver = new MutationObserver(() => initITL());
  itiObserver.observe(document.body, { childList: true, subtree: true });

  // Add global ITI styles to prevent layout shifts
  $("<style>")
    .text(
      `
    .iti { width: 100% !important; margin-bottom: 2px; }
    .iti__country-list { z-index: 10000 !important; }
    .phoneVal { padding-left: 95px !important; }
    .iti__checkbox, .iti input[type="checkbox"], [role="menuitemcheckbox"] input { display: none !important; }
    .iti__selected-flag { display: flex !important; align-items: center !important; }
    .iti__flag { display: inline-block !important; }
  `,
    )
    .appendTo("head");

  // Fallback triggers
  $(document).on("shown.bs.modal", initITL);
  $(document).on(
    "click",
    "[data-toggle='modal'], .blue-btn, .transparent-btn",
    function () {
      setTimeout(initITL, 300);
      setTimeout(initITL, 800);
    },
  );
  initITL();
  setTimeout(initITL, 1000);

  // --- UTM Session Clear Logic ---
  // If this is a new tab session (sessionStorage is empty) and URL doesn't have UTMs, clear server session UTMs
  if (!sessionStorage.getItem("utm_active")) {
    if (!window.location.search.includes("utm_")) {
      fetch((window.PMR_SETTINGS ? window.PMR_SETTINGS.baseUrl : "/") + "clearUtm")
        .then(function () {
          sessionStorage.setItem("utm_active", "1");
        })
        .catch(function (err) {
          console.error("UTM Clear Error:", err);
        });
    } else {
      sessionStorage.setItem("utm_active", "1");
    }
  }
}); // --- Standardized Validation Functions ---
window.checkName = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "name";
    $input = $context ? $context.find("#" + id) : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('input[name="fname"], input[name="name"]');
  }
  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  const val = $input.val().trim();
  let errorMessage = "";

  if (val === "") {
    errorMessage = "Field is required";
  } else if (!/^[A-Za-z\s\-']+$/.test(val)) {
    errorMessage = "Please enter a valid name (letters only)";
  }

  if (errorMessage) {
    if ($error.length) $error.text(errorMessage).show();
    $input.addClass("error");
    return false;
  } else {
    if ($error.length) $error.hide();
    $input.removeClass("error");
  }
  return true;
};

window.checkPhone = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "phone";
    $input = $context ? $context.find("#" + id) : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('input[name="phone"]');
  }
  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  const val = $input.val().trim();

  if (val === "") {
    if ($error.length) $error.hide();
    $input.removeClass("error");
    return true; // Optional as per requirement
  }

  let errorMessage = "";
  let normalized = val.replace(/[\s\-\(\)]/g, "");

  if (!/^\+?\d+$/.test(normalized)) {
    errorMessage = "Please enter a valid phone number (5-15 digits)";
  } else {
    let digits = normalized.replace(/^\+/, "");
    if (digits.length < 5 || digits.length > 15) {
      errorMessage = "Please enter 5-15 digits";
    }
  }

  if (errorMessage) {
    if ($error.length) $error.text(errorMessage).show();
    $input.addClass("error");
    return false;
  } else {
    if ($error.length) $error.hide();
    $input.removeClass("error");
  }
  return true;
};

window.checkCountry = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "country";
    $input = $context
      ? $context.find("#" + id + ', select[name="country"]')
      : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('select[name="country"]');
  }

  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  if (!$input.val()) {
    if ($error.length) $error.text("Please select your country").show();
    $input.addClass("error");
    return false;
  }
  if ($error.length) $error.hide();
  $input.removeClass("error");
  return true;
};

window.checkEmail = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "email";
    $input = $context ? $context.find("#" + id) : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('input[name="email"]');
  }
  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  const val = $input.val().trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let errorMessage = "";

  if (val === "") {
    errorMessage = "Field is required";
  } else if (!emailRegex.test(val)) {
    errorMessage = "Please enter a valid business email";
  }

  if (errorMessage) {
    if ($error.length) $error.text(errorMessage).show();
    $input.addClass("error");
    return false;
  } else {
    if ($error.length) $error.hide();
    $input.removeClass("error");
  }
  return true;
};

window.checkCompany = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "company";
    $input = $context ? $context.find("#" + id) : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('input[name="company"]');
  }
  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  const rawVal = $input.val();
  const val = rawVal.trim();
  let errorMessage = "";

  if (rawVal === "") {
    if ($input.prop("required")) {
      errorMessage = "Field is required";
    } else {
      if ($error.length) $error.hide();
      $input.removeClass("error");
      return true;
    }
  } else if (val.length < 2) {
    errorMessage = "Minimum 2 characters required";
  } else if (val.length > 100) {
    errorMessage = "Maximum 100 characters allowed";
  } else if (rawVal !== val) {
    errorMessage = "Leading or trailing spaces are not allowed";
  } else if (!/^[A-Za-z0-9\s&,.\-()]+$/.test(val)) {
    errorMessage = "Special characters allowed: & , . - ( )";
  } else if (!/[A-Za-z]/.test(val)) {
    errorMessage = "Company name must contain at least one alphabet";
  }

  if (errorMessage) {
    if ($error.length) $error.text(errorMessage).show();
    $input.addClass("error");
    return false;
  } else {
    if ($error.length) $error.hide();
    $input.removeClass("error");
  }
  return true;
};

window.checkMessage = function (id) {
  id = id || "message";
  const $input = $("#" + id);
  const $error = $("#" + id + "_error, #" + id + "-error");
  if (!$input.length) return true;

  if ($error.length) $error.hide();
  return true;
};

window.checkDesignation = function (id, $context) {
  let $input;
  if (id && typeof id === "object") {
    $input = $(id);
  } else {
    id = id || "designation";
    $input = $context ? $context.find("#" + id) : $("#" + id);
    if (!$input.length && $context)
      $input = $context.find('input[name="designation"]');
  }
  if (!$input || !$input.length) return true;

  const $parent = $input.closest(
    ".form-group, .form-field, .request-form__field-wrap",
  );
  const $error = $parent.find(
    ".error-msg, .kira_form_error, .error-message, #" +
    ($input.attr("id") || "") +
    "-error, #" +
    ($input.attr("id") || "") +
    "_error",
  );
  const val = $input.val().trim();
  let errorMessage = "";

  if (val === "") {
    if ($input.prop("required")) {
      errorMessage = "Field is required";
    } else {
      if ($error.length) $error.hide();
      $input.removeClass("error");
      return true;
    }
  } else if (val.length < 2) {
    errorMessage = "Minimum 2 characters required";
  } else if (!/^[A-Za-z\s\-']+$/.test(val)) {
    errorMessage = "Please enter a valid designation";
  }

  if (errorMessage) {
    if ($error.length) $error.text(errorMessage).show();
    $input.addClass("error");
    return false;
  } else {
    if ($error.length) $error.hide();
    $input.removeClass("error");
  }
  return true;
};

window.checkGeneralField = function (id) {
  if (id === "company") return window.checkCompany(id);
  if (id === "designation") return window.checkDesignation(id);
  return true;
};

// Removed duplicate checkCountry definition

window.checkTerms = function (id) {
  id = id || "terms";
  const $cb = $("#" + id).length
    ? $("#" + id)
    : $('input[name="condition_check"]');
  const $error = $(
    "#" +
    id +
    "_error, #" +
    id +
    "-error, .pmr-request-error-terms, #career_terms_error",
  );

  if ($cb.length && !$cb.is(":checked")) {
    if ($error.length) $error.text("Please agree to the privacy policy").show();
    return false;
  }
  if ($error.length) $error.hide();
  return true;
};

window.check =
  window.checkContactForm =
  window.checkResellerForm =
  function () {
    const $form = $(event.target);
    if (
      $form.hasClass("career-custom-form") ||
      $form.hasClass("contact-form-grid") ||
      $form.hasClass("reseller-custom-form")
    ) {
      return pmrValidateForm($form);
    }
    return true; // Fallback to handleGenericSubmit for others
  };

function validateRecaptcha(form) {
  var response = "";
  if (typeof turnstile !== "undefined") {
    var widget = form ? $(form).find(".cf-turnstile")[0] : undefined;
    response = turnstile.getResponse(widget);
  }

  const $error = form
    ? $(form).find(".captcha-error-msg, #captcha_error, .captcha-error")
    : $(".captcha-error-msg, #captcha_error, .captcha-error");

  if (!response || response.length === 0) {
    $error.text("Please fill out the captcha.").show();
    return false;
  } else {
    $error.hide();
  }
  return true;
}

function handleGenericSubmit(e) {
  console.log("SH Form submit intercepted for validation");
  var $form = $(this);
  if (
    e.isDefaultPrevented() ||
    $form.attr("id") === "search-form" ||
    $form.attr("id") === "sitewideModalForm" ||
    $form.attr("id") === "pmrModalForm"
  )
    return;

  e.preventDefault();

  var isValid = true;
  if (
    $form.hasClass("career-custom-form") ||
    $form.hasClass("contact-form-grid") ||
    $form.hasClass("reseller-custom-form")
  ) {
    if (typeof pmrValidateForm === "function") {
      isValid = pmrValidateForm($form);
    }
  } else {
    if (
      !window.checkName(
        $form.find('input[name="fname"], input[name="name"]')[0],
        $form,
      )
    )
      isValid = false;
    if (!window.checkEmail($form.find('input[name="email"]')[0], $form))
      isValid = false;
    if (!window.checkCountry($form.find('select[name="country"]')[0], $form))
      isValid = false;
    if (!window.checkPhone($form.find('input[name="phone"]')[0], $form))
      isValid = false;
    if (!window.checkCompany($form.find('input[name="company"]')[0], $form))
      isValid = false;
    if (
      !window.checkDesignation(
        $form.find('input[name="designation"]')[0],
        $form,
      )
    )
      isValid = false;

    var $msg = $form.find('textarea[name="comment"], textarea[name="message"]');
    if ($msg.length && !window.checkMessage($msg.attr("id"))) isValid = false;
    if (!validateRecaptcha($form)) isValid = false;
  }

  if (!isValid) return false;

  var $btn = $form.find('button[type="submit"]');
  var originalBtnHtml = $btn.html();
  $btn.prop("disabled", true).html("Submitting...");

  var formData = new FormData($form[0]);
  var url = $form.attr("action");

  $.ajax({
    url: url,
    type: "POST",
    data: formData,
    contentType: false,
    processData: false,
    dataType: "json",
    success: function (response) {
      if (response.status === "success" || response.success) {
        $form[0].reset();
        window.location.href = response.redirect || "/thank-you";
      } else {
        // alert(response.message || "Submission failed. Please try again.");
        $btn.prop("disabled", false).html(originalBtnHtml);
        if (window.turnstile) turnstile.reset();
      }
    },
    error: function (xhr, status, error) {
      console.error("Submission error:", status, error);
      // alert("A server error occurred. Please try again.");
      $btn.prop("disabled", false).html(originalBtnHtml);
      if (window.turnstile) turnstile.reset();
    },
  });
}

// Bind generic handler
$(document).on(
  "submit",
  "form:not(#search-form):not(.request-form__main)",
  handleGenericSubmit,
);

$(document).ready(function () {
  $(".featured-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });
});

$(document).ready(function () {
  if ($(window).width() <= 768) {
    //destroy slider first
    if ($(".team-members").hasClass("slick-initialized")) {
      $(".team-members").slick("unslick");
    }
    //move first two cards
    $(".team-card-container .team-card").prependTo(".team-members");
    // remove wrapper\
    $(".team-card-container").remove();
    // initialize slider again
    $(".team-members").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      centerMode: false,
    });
  }
});

// ========================================
// ========================================
// Google reCAPTCHA onloadCallback
// ========================================
// Google reCAPTCHA onloadCallback removed

// Turnstile Token Management - Disable Submit Until Token Received
(function () {
  function setSubmitButtonVerifying(btn) {
    if (!btn) return;

    if (!btn.dataset.turnstileOriginalText) {
      btn.dataset.turnstileOriginalText =
        btn.tagName === "INPUT" ? btn.value : btn.innerHTML;
    }

    if (btn.tagName === "INPUT") {
      btn.value = "Verifying...";
    } else {
      btn.innerHTML = "Verifying...";
    }
  }

  function restoreSubmitButtonText(btn) {
    if (!btn || !btn.dataset.turnstileOriginalText) return;

    if (btn.tagName === "INPUT") {
      btn.value = btn.dataset.turnstileOriginalText;
    } else {
      btn.innerHTML = btn.dataset.turnstileOriginalText;
    }

    delete btn.dataset.turnstileOriginalText;
  }

  function disableAllSubmitButtons() {
    console.log("SH inside disabled all btn");

    document
      .querySelectorAll('form button[type="submit"], form input[type="submit"]')
      .forEach(function (btn) {
        const form = btn.closest("form");
        if (form && form.querySelector(".cf-turnstile")) {
          btn.disabled = true;
          btn.style.opacity = "0.6";
          btn.style.cursor = "not-allowed";
          btn.dataset.turnstileDisabled = "true";
          setSubmitButtonVerifying(btn);
        }
      });
  }

  function enableSubmitButton(token) {
    console.log("SH token enable button");

    document.querySelectorAll(".cf-turnstile").forEach(function (widget) {
      const form = widget.closest("form");
      if (form) {
        const btn = form.querySelector(
          'button[type="submit"], input[type="submit"]',
        );
        if (btn && btn.dataset.turnstileDisabled === "true") {
          btn.disabled = false;
          btn.style.opacity = "";
          btn.style.cursor = "";
          restoreSubmitButtonText(btn);
          delete btn.dataset.turnstileDisabled;
        }
      }
    });
  }

  function disableSubmitButton() {
    console.log("SH inside disabled submit btn");
    document.querySelectorAll(".cf-turnstile").forEach(function (widget) {
      const form = widget.closest("form");
      if (form) {
        const btn = form.querySelector(
          'button[type="submit"], input[type="submit"]',
        );
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = "0.6";
          btn.style.cursor = "not-allowed";
          btn.dataset.turnstileDisabled = "true";
          setSubmitButtonVerifying(btn);
        }
      }
    });
  }

  window.turnstileCallback = function (token) {
    console.log("SH callback turnstile");
    enableSubmitButton(token);
    // alert("got token, enabled btn")
  };

  window.onError = function (errorCode) {
    console.error("SH Turnstile error:", errorCode);
    enableSubmitButton(null);
  };

  window.onExpired = function () {
    console.warn("SH Turnstile token expired");
    enableSubmitButton(null);
  };

  window.onTimeout = function () {
    console.warn("SH Turnstile timeout");
    enableSubmitButton(null);
  };

  if (document.readyState === "loading") {
    console.log("SH  loding if ");

    document.addEventListener("DOMContentLoaded", disableAllSubmitButtons);
  } else {
    console.log("SH  loding else ");
    disableAllSubmitButtons();
  }

  // document.addEventListener("reset", function (e) {
  //   if (
  //     e.target.tagName === "FORM" &&
  //     e.target.querySelector(".cf-turnstile")
  //   ) {
  //     console.log("SH form reset, disabling submit btn");
  //     // setTimeout(disableAllSubmitButtons, 100);
  //   }
  // });

  document.addEventListener("click", function (e) {
    if (e.target.matches('[data-toggle="modal"]')) {
      setTimeout(function () {
        console.log("SH modal opened, disabling submit btn");
        disableAllSubmitButtons();
        // Reinitialize turnstile for modal forms
        if (typeof turnstile !== "undefined") {
          document.querySelectorAll(".cf-turnstile").forEach(function (widget) {
            if (widget.closest(".modal")) {
              try {
                turnstile.reset(widget);
              } catch (e) {
                console.warn("Turnstile reset failed:", e);
              }
            }
          });
        }
      }, 500);
    }
  });

  // Watch for modal show events
  $(document).on("shown.bs.modal show.bs.modal", function () {
    setTimeout(function () {
      console.log("SH Bootstrap modal shown, disabling submit btn");
      disableAllSubmitButtons();
    }, 100);
  });

  // Watch for pmr-custom-modal specifically
  const checkModalVisibility = function () {
    const modal = document.querySelector("#pmrLeadModal");
    if (
      modal &&
      (modal.classList.contains("show") || modal.style.display === "block")
    ) {
      console.log("SH custom modal visible, disabling submit btn");
      setTimeout(disableAllSubmitButtons, 100);
    }
  };

  // Watch for custom modal open
  const modalObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        checkModalVisibility();
      }
      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === 1 &&
          (node.classList.contains("modal") ||
            node.classList.contains("show") ||
            node.classList.contains("pmr-custom-modal"))
        ) {
          setTimeout(disableAllSubmitButtons, 100);
          console.log("SH custom modal added, disabling submit btn");
        }
      });
    });
  });
  modalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style"],
  });
})();

// Removed manual checkContactForm implementation as it's now handled by generic submit

// Related Blogs Slider - Blog Detail Page
$(document).ready(function () {
  // Pricing Cards Slider - Mobile Only
  if ($(".pricing-grid").length) {
    function initPricingSlider() {
      if ($(window).width() < 768) {
        if (!$(".pricing-grid").hasClass("slick-initialized")) {
          $(".pricing-grid").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            centerMode: false,
            variableWidth: false,
            initialSlide: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="Previous"></button>',
            nextArrow:
              '<button type="button" class="slick-next" aria-label="Next"></button>',
          });
        }
      } else {
        if ($(".pricing-grid").hasClass("slick-initialized")) {
          $(".pricing-grid").slick("unslick");
        }
      }
    }

    initPricingSlider();
    $(window).on("resize", initPricingSlider);
  }
});

// Trending Reports AJAX Loading
$(document).ready(function () {
  $(".trending-reports__tab").on("click", function () {
    var $section = $(this).closest(".trending-reports");
    var ajax_url = $section.data("ajax-url");
    var base_url = $section.data("base-url");

    var category_id = $(this).data("category-id");
    var category_slug = $(this).data("category-slug");
    var $tabs = $(".trending-reports__tab");
    var $grid = $("#trending-reports-grid");
    var $loader = $("#trending-loader");
    var $viewAllBtn = $("#trending-view-all");

    // Update active tab UI
    $tabs.removeClass("active");
    $(this).addClass("active");

    // Update "View Reports" link
    if (category_slug && base_url) {
      $viewAllBtn.attr("href", base_url + "industries/" + category_slug);
    }

    // Show loader and hide grid (using opacity for smooth transition)
    $loader.addClass("active");
    $grid.css("opacity", "0.3");

    if (ajax_url) {
      $.ajax({
        url: ajax_url,
        type: "POST",
        data: { category_id: category_id },
        success: function (response) {
          // Latest delay to show spinner clearly
          setTimeout(function () {
            $loader.removeClass("active");
            $grid.css("opacity", "1");
            $grid.html(response);
          }, 300);
        },
        error: function () {
          $loader.removeClass("active");
          $grid.css("opacity", "1");
          // alert("Something went wrong. Please try again.");
        },
      });
    }
  });
});

// Additive form validation layer
$(document).ready(function () {
  function pmrGetErrorElement($field, fallbackId) {
    var $error = fallbackId ? $("#" + fallbackId) : $();

    if (!$error.length && $field.attr("id")) {
      $error = $("#" + $field.attr("id") + "_error");
    }

    if (!$error.length) {
      var $container = $field.closest(
        ".form-group, .form-field, .file-upload-wrapper",
      );
      $error = $container.find(".error-message, .form-error").last();
    }

    if (!$error.length) {
      var className = $field.closest(".form-field").length
        ? "form-error"
        : "error-message";
      $error = $("<span>", {
        class: className,
        css: { display: "none" },
      });
      $field
        .closest(".form-group, .form-field, .file-upload-wrapper")
        .append($error);
    }

    return $error;
  }

  function pmrShowError($field, fallbackId, message) {
    pmrGetErrorElement($field, fallbackId).text(message).show();
  }

  function pmrClearError($field, fallbackId) {
    pmrGetErrorElement($field, fallbackId).text("").hide();
  }

  function pmrValidateCountry($form) {
    var $field = $form.find("#country").first();
    if (!$field.length) return true;
    var val = $field.val();
    if (!val || val === "") {
      pmrShowError($field, "country_error", "Please select your country");
      return false;
    }
    pmrClearError($field, "country_error");
    return true;
  }

  function pmrValidateName($form) {
    var $field = $form.find("#name").first();
    if (!$field.length) return true;

    var rawValue = $field.val() || "";
    var value = rawValue.replace(/\s+$/, "");
    var error = "";

    if (rawValue.indexOf(" ") === 0) {
      error = "Leading spaces not allowed";
    } else if (value === "") {
      error = "Field is required";
    } else if (value.length < 2) {
      error = "Minimum length: 2 characters";
    } else if (value.length > 100) {
      error = "Maximum length: 100 characters";
    } else if (!/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/.test(value)) {
      error = "Only letters, spaces, hyphens, and apostrophes are allowed";
    }

    if (error) {
      pmrShowError($field, "name_error", error);
      return false;
    }

    pmrClearError($field, "name_error");
    return true;
  }

  function pmrValidatePhone($form) {
    var $field = $form.find("#phone").first();
    if (!$field.length) return true;

    var rawValue = $field.val() || "";
    var value = rawValue.replace(/\s+$/, "");
    if (value === "") {
      pmrClearError($field, "phone_error");
      return true;
    }

    var normalizedValue = value.replace(/[\s\-()]/g, "");
    var error = "";

    if (rawValue.indexOf(" ") === 0) {
      error = "Leading spaces not allowed";
    } else if (!/^\+?[\d\s\-\(\)]+$/.test(normalizedValue)) {
      error = "Only digits are allowed, with an optional leading +";
    } else {
      var digits = normalizedValue.replace(/^\+/, "");
      if (digits.length < 7) {
        error = "Minimum length: 7 digits";
      } else if (digits.length > 15) {
        error = "Maximum length: 15 digits";
      }
    }

    if (error) {
      pmrShowError($field, "phone_error", error);
      return false;
    }

    pmrClearError($field, "phone_error");
    return true;
  }

  function pmrValidateEmail($form) {
    var $field = $form.find("#email").first();
    if (!$field.length) return true;

    var rawValue = $field.val() || "";
    var value = rawValue.replace(/\s+$/, "");
    var error = "";
    var emailRegex =
      /^(?=.{5,100}$)(?=.{1,64}@)[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;

    if (rawValue.indexOf(" ") === 0) {
      error = "Leading spaces not allowed";
    } else if (value === "") {
      error = "Field is required";
    } else if (value.length < 5) {
      error = "Minimum length: 5 characters";
    } else if (value.length > 100) {
      error = "Maximum length: 100 characters";
    } else if (/\s/.test(value)) {
      error = "Spaces are not allowed";
    } else if (
      value.charAt(0) === "." ||
      value.charAt(value.length - 1) === "."
    ) {
      error = "Email must not start or end with .";
    } else if (value.indexOf("..") !== -1) {
      error = "Consecutive dots are not allowed";
    } else if ((value.match(/@/g) || []).length !== 1) {
      error = "Email must contain exactly one @ symbol";
    } else if (!emailRegex.test(value)) {
      error = "Please enter a valid email address";
    }

    if (error) {
      pmrShowError($field, "email_error", error);
      return false;
    }

    pmrClearError($field, "email_error");
    return true;
  }

  function pmrValidateMessage($form) {
    var $field = $form.find("#message").first();
    if (!$field.length) return true;

    var rawValue = $field.val() || "";
    var value = rawValue.replace(/\s+$/, "");
    var error = "";

    if (rawValue.indexOf(" ") === 0) {
      error = "Leading spaces not allowed";
    }

    if (error) {
      pmrShowError($field, "message_error", error);
      return false;
    }

    pmrClearError($field, "message_error");
    return true;
  }

  function pmrValidateResume($form) {
    var $field = $form.find("#resume_file").first();
    if (!$field.length) return true;

    var error = "";
    var files = $field[0].files || [];

    if (!files.length) {
      error = "Field is required";
    } else if (files.length > 1) {
      error = "Only one file allowed";
    } else {
      var file = files[0];
      var extension = file.name.split(".").pop().toLowerCase();
      if ($.inArray(extension, ["pdf", "doc", "docx"]) === -1) {
        error = "Allowed file types: PDF, DOC, DOCX";
      } else if (file.size > 5 * 1024 * 1024) {
        error = "Maximum file size allowed is 5 MB";
      } else if (file.size === 0) {
        error = "File must not be corrupted (0 bytes)";
      }
    }

    if (error) {
      pmrShowError($field, "resume_error", error);
      return false;
    }

    pmrClearError($field, "resume_error");
    return true;
  }

  function pmrValidateCaptcha($form) {
    var $captchaError = $form.find("#captcha_error");
    if (!$captchaError.length) return true;

    var response = "";
    if (typeof turnstile !== "undefined") {
      response = turnstile.getResponse();
    }

    if (!response || response.length === 0) {
      $captchaError.show();
      return false;
    }

    $captchaError.hide();
    return true;
  }

  function pmrValidateCompany($form) {
    var $field = $form.find("#company").first();
    if (!$field.length) return true;
    var val = $field.val().trim();
    if (val.length > 0 && val.length < 2) {
      pmrShowError(
        $field,
        "company_error",
        "Please enter a valid company name",
      );
      return false;
    }
    pmrClearError($field, "company_error");
    return true;
  }

  function pmrValidateDesignation($form) {
    var $field = $form.find("#designation").first();
    if (!$field.length) return true;
    var val = $field.val().trim();
    if (val.length > 0 && val.length < 2) {
      pmrShowError(
        $field,
        "designation_error",
        "Please enter a valid job title",
      );
      return false;
    }
    pmrClearError($field, "designation_error");
    return true;
  }

  window.pmrValidateForm = function ($form) {
    var checks = [
      { valid: pmrValidateName($form), field: "#name" },
      { valid: pmrValidateCompany($form), field: "#company" },
      { valid: pmrValidateDesignation($form), field: "#designation" },
      { valid: pmrValidateCountry($form), field: "#country" },
      { valid: pmrValidatePhone($form), field: "#phone" },
      { valid: pmrValidateEmail($form), field: "#email" },
      { valid: pmrValidateMessage($form), field: "#message" },
      { valid: pmrValidateResume($form), field: "#resume_file" },
      { valid: pmrValidateCaptcha($form), field: null },
    ];

    for (var i = 0; i < checks.length; i++) {
      if (!checks[i].valid) {
        if (checks[i].field) {
          var $focusField = $form.find(checks[i].field).first();
          if ($focusField.length) {
            $focusField.focus();
          }
        }
        return false;
      }
    }

    return true;
  };

  // Removed redundant submit handler as Careers is now handled by handleGenericSubmit
  /*
  $(document).on(
    "submit",
    ".career-custom-form, .contact-form-grid",
    function (e) {
      if (!pmrValidateForm($(this))) {
        e.preventDefault();
        return false;
      }
    },
  );
  */

  $(document).on(
    "blur change",
    ".career-custom-form #name, .contact-form-grid #name, .reseller-custom-form #name",
    function () {
      pmrValidateName($(this).closest("form"));
    },
  );

  $(document).on(
    "blur change",
    ".career-custom-form #phone, .contact-form-grid #phone, .reseller-custom-form #phone",
    function () {
      pmrValidatePhone($(this).closest("form"));
    },
  );

  $(document).on(
    "blur change",
    ".career-custom-form #email, .contact-form-grid #email, .reseller-custom-form #email",
    function () {
      pmrValidateEmail($(this).closest("form"));
    },
  );

  $(document).on(
    "blur change",
    ".career-custom-form #message, .contact-form-grid #message, .reseller-custom-form #message",
    function () {
      pmrValidateMessage($(this).closest("form"));
    },
  );

  $(document).on("change", ".career-custom-form #resume_file", function () {
    pmrValidateResume($(this).closest("form"));
  });
});

// Request customization form validation
$(document).ready(function () {
  function pmrRequestGetFields($form) {
    var $inputs = $form.find(
      ".request-form__main-flex .request-form__main-field",
    );

    return {
      name: $form.find('[name="fname"]').first().length
        ? $form.find('[name="fname"]').first()
        : $form.find('[name="name"]').first(),
      email: $form.find('[name="email"]'),
      phone: $form.find('[name="phone"]'),
      company: $form.find('[name="company"]'),
      designation: $form.find('[name="designation"]'),
      country: $form.find('[name="country"]'),
      message: $form
        .find("textarea.request-form__main-field--textarea")
        .first(),
      terms: $form.find("#terms").first(),
    };
  }

  function pmrRequestErrorElement($field, key) {
    var markerClass = "pmr-request-error-" + key;
    var $error;
    if ($field.attr("type") === "checkbox") {
      $error = $field
        .closest(".request-form__main-terms")
        .find("." + markerClass)
        .first();
    } else {
      $error = $field
        .closest(".request-form__field-wrap")
        .find("." + markerClass)
        .first();
    }
    return $error;
  }

  function pmrRequestShowError($field, key, message) {
    if (!$field || !$field.length) return;
    pmrRequestErrorElement($field, key).text(message).show();
  }

  function pmrRequestClearError($field, key) {
    if (!$field || !$field.length) return;
    pmrRequestErrorElement($field, key).text("").hide();
  }

  function pmrRequestValidateName($field) {
    if (!$field || !$field.length) return true;
    var value = ($field.val() || "").trim();
    var error = "";

    if (value === "") {
      error = "Field is required";
    } else if (/[^a-zA-Z\s]/.test(value)) {
      error = "Please enter a valid name (letters only)";
    } else if (value.length > 100) {
      error = "Maximum length: 100 characters";
    }

    if (error) {
      pmrRequestShowError($field, "name", error);
      return false;
    }

    pmrRequestClearError($field, "name");
    return true;
  }

  function pmrRequestValidateCountry($field) {
    if (!$field || !$field.length) return true;
    var val = $field.val();
    if (!val || val === "") {
      pmrRequestShowError($field, "country", "Please select your country");
      return false;
    }
    pmrRequestClearError($field, "country");
    return true;
  }

  window.pmrRequestValidateCountry = pmrRequestValidateCountry;

  function pmrRequestValidateEmail($field) {
    if (!$field || !$field.length) return true;
    var value = ($field.val() || "").trim();
    var error = "";
    var emailRegex =
      /^(?=.{5,100}$)(?=.{1,64}@)[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;

    if (value === "") {
      error = "Field is required";
    } else if (/\s/.test(value)) {
      error = "Please enter a valid email";
    } else if (!emailRegex.test(value)) {
      error = "Please enter a valid email";
    }

    if (error) {
      pmrRequestShowError($field, "email", error);
      return false;
    }

    pmrRequestClearError($field, "email");
    return true;
  }

  function pmrRequestValidatePhone($field) {
    if (!$field || !$field.length) return true;
    var rawValue = $field.val() || "";
    var value = rawValue.trim();
    if (value === "") {
      pmrRequestClearError($field, "phone");
      return true; // Optional now
    }

    var normalizedValue = value.replace(/[\s\-()]/g, "");
    var error = "";
    if (/[a-zA-Z]/.test(value)) {
      error = "Please enter a valid phone number (5-15 digits)";
    } else if (normalizedValue.length < 5 || normalizedValue.length > 15) {
      error = "Please enter a valid phone number (5-15 digits)";
    }
    if (error) {
      pmrRequestShowError($field, "phone", error);
      return false;
    }
    pmrRequestClearError($field, "phone");
    return true;
  }

  function pmrRequestValidateCompany($field) {
    if (!$field || !$field.length) return true;
    var value = ($field.val() || "").trim();
    var error = "";

    if (value === "") {
      pmrRequestClearError($field, "company");
      return true;
    } else if (/[^a-zA-Z0-9\s&.,\-'()]+$/.test(value)) {
      error = "Please enter your company name";
    }

    if (error) {
      pmrRequestShowError($field, "company", error);
      return false;
    }

    pmrRequestClearError($field, "company");
    return true;
  }

  function pmrRequestValidateDesignation($field) {
    if (!$field || !$field.length) return true;
    var value = ($field.val() || "").trim();
    var error = "";

    if (value === "") {
      pmrRequestClearError($field, "designation");
      return true;
    } else if (/[^a-zA-Z\s]/.test(value)) {
      error = "Please enter your designation";
    }

    if (error) {
      pmrRequestShowError($field, "designation", error);
      return false;
    }

    pmrRequestClearError($field, "designation");
    return true;
  }

  function pmrRequestValidateMessage($field) {
    if (!$field || !$field.length) return true;
    var value = ($field.val() || "").trim();
    var error = "";
    if (value.length === 0) {
      // error = "Field is required";
      pmrRequestClearError($field, "message");
      return true;
    }
    if (error) {
      pmrRequestShowError($field, "message", error);
      return false;
    }
    pmrRequestClearError($field, "message");
    return true;
  }

  function pmrRequestValidateTerms($field) {
    if (!$field || !$field.length) return true;
    if ($field.is(":checked")) {
      pmrRequestClearError($field, "terms");
      return true;
    }

    pmrRequestShowError(
      $field,
      "terms",
      "Please accept the privacy policy and terms and conditions",
    );
    return false;
  }

  $(document).on("submit", ".request-form__main", function (e) {
    var $form = $(this);
    var fields = pmrRequestGetFields($form);
    var checks = [
      { valid: pmrRequestValidateName(fields.name), field: fields.name },
      { valid: pmrRequestValidateEmail(fields.email), field: fields.email },
      {
        valid: pmrRequestValidateCountry(fields.country),
        field: fields.country,
      },
      { valid: pmrRequestValidatePhone(fields.phone), field: fields.phone },
      {
        valid: pmrRequestValidateCompany(fields.company),
        field: fields.company,
      },
      {
        valid: pmrRequestValidateDesignation(fields.designation),
        field: fields.designation,
      },
      {
        valid: pmrRequestValidateMessage(fields.message),
        field: fields.message,
      },
    ];

    for (var i = 0; i < checks.length; i++) {
      if (!checks[i].valid) {
        e.preventDefault();
        if (checks[i].field && checks[i].field.length) {
          checks[i].field.focus();
        }
        return false;
      }
    }

    // If valid, perform AJAX submission to match other forms' behavior
    e.preventDefault();
    var $btn = $form.find('button[type="submit"]');
    var originalBtnHtml = $btn.html();
    $btn.prop("disabled", true).html("Submitting...");

    var formData = new FormData($form[0]);
    var url = $form.attr("action");

    $.ajax({
      url: url,
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      dataType: "json",
      success: function (response) {
        if (response.status === "success" || response.success) {
          $form[0].reset();
          window.location.href = response.redirect || "/thank-you";
        }
        //  else {
        //   alert(response.message || "Submission failed. Please try again.");
        //   $btn.prop("disabled", false).html(originalBtnHtml);
        //   if (typeof turnstile !== "undefined") turnstile.reset();
        // }
      },
      error: function (xhr, status, error) {
        console.error("Submission error:", status, error);
        alert("A server error occurred. Please try again.");
        $btn.prop("disabled", false).html(originalBtnHtml);
        if (typeof turnstile !== "undefined") turnstile.reset();
      },
    });
  });

  $(document).on(
    "blur change",
    ".request-form__main .request-form__main-flex .request-form__main-field",
    function () {
      var $form = $(this).closest("form");
      var fields = pmrRequestGetFields($form);
      var $field = $(this);

      if ($field.is(fields.name)) pmrRequestValidateName($field);
      if ($field.is(fields.email)) pmrRequestValidateEmail($field);
      if ($field.is(fields.phone)) pmrRequestValidatePhone($field);
      if ($field.is(fields.company)) pmrRequestValidateCompany($field);
      if ($field.is(fields.designation)) pmrRequestValidateDesignation($field);
    },
  );

  $(document).on(
    "blur change",
    ".request-form__main textarea.request-form__main-field--textarea",
    function () {
      pmrRequestValidateMessage($(this));
    },
  );

  $(document).on("change", ".request-form__main #terms", function () {
    pmrRequestValidateTerms($(this));
  });
});

// Request Form Tabs + Hidden Fields (form-type & country-selected)
// Request Form Tabs + Hidden Fields (form-type & country-selected)
function updateRequestFormContent(label) {
  var titleEl = document.querySelector(".request-form__content-title");
  var subtextEl = document.querySelector(".request-form__main-text");
  var commentEl = document.querySelector(".request-form__main-field--textarea");
  var termsLabelEl = document.querySelector(".request-form__main-terms--label");
  const privacyUrl = window.PMR_SETTINGS
    ? window.PMR_SETTINGS.privacyUrl
    : "/privacy-policy";
  const termsUrl = window.PMR_SETTINGS
    ? window.PMR_SETTINGS.termsUrl
    : "/terms-and-conditions";

  if (!titleEl) return;

  if (label === "Inquiry Before Buying") {
    titleEl.innerText =
      "We value your investment and offer free customization with every report to fulfil your exact research needs.";
    if (subtextEl) subtextEl.style.display = "block";
    subtextEl.innerText = `We take great pride in "Delivering game-changing business opportunities reports with report customizations", so please don't hesitate to share with us your unique interests and business difficulties in much more detail.`;
    if (commentEl)
      commentEl.setAttribute(
        "placeholder",
        "Please share your specific requirements (If Any)",
      );
    if (termsLabelEl)
      termsLabelEl.innerHTML = `I agree to <a href="${privacyUrl}" target="_blank">Privacy policy</a>, 
   <a href="${termsUrl}" target="_blank">Terms and conditions</a> 
   and consent to data usage.`;
  } else if (label === "Request Customization") {
    titleEl.innerText =
      "Please fill out the form to request a customized copy of the research report.";
    if (subtextEl) {
      subtextEl.style.display = "block";
      subtextEl.innerText = `We take great pride in "Delivering game-changing business opportunities reports with report customizations", so please don't hesitate to share with us your unique interests and business difficulties in much more detail.`;
    }
    if (commentEl)
      commentEl.setAttribute(
        "placeholder",
        "Please share your specific requirements (If Any)",
      );
    if (termsLabelEl)
      termsLabelEl.innerHTML = `I agree to <a href="${privacyUrl}">Privacy policy</a>, 
   <a href="${termsUrl}">Terms and conditions</a> 
   and consent to data usage.`;
  } else if (label === "Talk To Our Analyst") {
    titleEl.innerText =
      "Please fill out the form to speak with one of our research analyst.";
    if (subtextEl) {
      subtextEl.style.display = "block";
      subtextEl.innerText = `We take great pride in "Delivering game-changing business opportunities reports with report customizations", so please don't hesitate to share with us your unique interests and business difficulties in much more detail.`;
    }
    if (commentEl)
      commentEl.setAttribute(
        "placeholder",
        "Please share your specific requirements (If Any)",
      );
    if (termsLabelEl)
      termsLabelEl.innerHTML = `I agree to <a href="${privacyUrl}" target="_blank">Privacy policy</a>, 
   <a href="${termsUrl}" target="_blank">Terms and conditions</a> 
   and consent to data usage.`;
  }
}

document
  .querySelectorAll(".request-form__tabs .request-form__tab")
  .forEach(function (tab) {
    tab.addEventListener("click", function () {
      const form = document.querySelector(".request-form__main");
      if (form) {
        // Clear visible fields
        form
          .querySelectorAll(
            ".request-form__main-field, .request-form__main-field--textarea",
          )
          .forEach((input) => {
            input.value = "";
            // Reset intl-tel-input to default country if present
            if (input.iti) {
              input.iti.setCountry("in");
            }
          });

        // Reset checkbox
        const checkbox = form.querySelector('input[name="condition_check"]');
        if (checkbox) checkbox.checked = false;

        // Hide error messages
        form.querySelectorAll(".error-message").forEach((err) => {
          err.style.display = "none";
          err.innerText = "";
        });

        // Reset Turnstile if initialized
        if (typeof turnstile !== "undefined") {
          try {
            turnstile.reset();
          } catch (e) { }
        }
      }

      document
        .querySelectorAll(".request-form__tabs .request-form__tab")
        .forEach(function (t) {
          t.classList.remove("active");
          t.setAttribute("aria-selected", "false");
        });
      this.classList.add("active");
      this.setAttribute("aria-selected", "true");

      var formTypeInput = document.getElementById("form-type");
      if (formTypeInput) formTypeInput.value = this.getAttribute("aria-label");
      var formRequestTypeInput = document.getElementById("form_request_type");
      var formNameInput = document.getElementById("form-type");
      var label = this.getAttribute("aria-label");
      var formDataValue = this.getAttribute("data-form-data");

      if (formRequestTypeInput && formDataValue) {
        formRequestTypeInput.value = formDataValue;
      }
      if (formNameInput) {
        formNameInput.value = label;
      }

      updateRequestFormContent(label);

      // Show purchase options only for Request Customization tab
      var purchaseWrap = document.getElementById("purchase-options-wrap");
      if (purchaseWrap) {
        purchaseWrap.style.display =
          label === "Request Customization" ? "" : "none";
        // Uncheck all when switching away
        if (label !== "Request Customization") {
          purchaseWrap
            .querySelectorAll('input[type="checkbox"]')
            .forEach(function (cb) {
              cb.checked = false;
            });
        }
      }
    });
  });

// Set initial form-type value from the active tab on page load
(function () {
  var activeTab = document.querySelector(
    ".request-form__tabs .request-form__tab.active",
  );
  var formTypeInput = document.getElementById("form-type");
  if (activeTab && formTypeInput) {
    var label = activeTab.getAttribute("aria-label");
    formTypeInput.value = label;
    updateRequestFormContent(label);
  }

  // intl-tel-input sync removed in favor of separate country dropdown

  // Populate browser, server_url, ip_address
  const browserField = document.getElementById("browser");
  const urlField = document.getElementById("server_url");
  const ipField = document.getElementById("ip_address");

  if (browserField) browserField.value = navigator.userAgent;

  // URL Tracking for Enquiry Forms (Client-side to bypass cache)
  const currentUrl = window.location.href;
  const lastUrl = sessionStorage.getItem("last_page_url");

  if (urlField) {
    const targetReferrerRoutes = [
      "inquiry-before-buying",
      "talk-to-our-analyst",
      "request-customization",
    ];
    const isTargetPage = targetReferrerRoutes.some((route) =>
      window.location.pathname.includes(route),
    );

    if (isTargetPage) {
      // Use document.referrer if it's from our site and not the current page
      if (
        document.referrer &&
        document.referrer.includes(window.location.hostname) &&
        !document.referrer.includes(window.location.pathname)
      ) {
        urlField.value = document.referrer;
      } else if (lastUrl && !lastUrl.includes(window.location.pathname)) {
        // Use our sessionStorage track as a secondary fallback
        urlField.value = lastUrl;
      } else {
        // Final fallback to Current URL (already set by PHP or window.location.href)
        if (!urlField.value) urlField.value = window.location.href;
      }
    } else {
      urlField.value = window.location.href;
    }
  }

  // Update last_page_url for next request (skip enquiry pages to keep the "previous" context)
  const isTargetPageForTracking = [
    "enquiry-before-buying",
    "talk-to-our-analyst",
    "request-customization",
    "submit-request-sample",
  ].some((route) => window.location.pathname.includes(route));

  if (!isTargetPageForTracking) {
    sessionStorage.setItem("last_page_url", currentUrl);
  }

  // Populate UTM parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  ["source", "medium", "campaign", "term", "content"].forEach((param) => {
    const field = document.getElementById("utm_" + param);
    if (field && urlParams.has("utm_" + param)) {
      field.value = urlParams.get("utm_" + param);
    }
  });
})();

// Form Terms Checkbox logic removed in favor of explicit validation in check() functions;

// Restrict leading spaces on all inputs
$(document).on(
  "input",
  "input[type='text'], input[type='tel'], input[type='email'], textarea",
  function () {
    if (this.value.startsWith(" ")) {
      this.value = this.value.replace(/^\s+/, "");
    }
  },
);

// --- Client Listing Load More ---
$(document).ready(function () {
  $(document).on("click", "#view-more-clients", function (e) {
    if ($(".js-hidden-client").length) {
      e.preventDefault();
      $(".js-hidden-client").css("display", "flex").hide().fadeIn();
      $(this).fadeOut();
      $(".fade-line").fadeOut();
    }
  });
});

// --- Shared Components & Global Logic ---
$(function () {
  // Sticky Header Logic
  const customStickyHeader = document.querySelector(".report-sticky-header");
  const body = document.body;

  if (customStickyHeader) {
    let ticking = false;
    window.addEventListener("scroll", function () {
      let y = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          const mainHeader = document.querySelector(".main-header");
          if (y > 5) {
            if (!customStickyHeader.classList.contains("show")) {
              customStickyHeader.classList.add("show");
              customStickyHeader.classList.remove("hide");
              if (mainHeader) mainHeader.classList.add("hide-for-sticky");
            }
          } else {
            if (customStickyHeader.classList.contains("show")) {
              customStickyHeader.classList.add("hide");
              customStickyHeader.classList.remove("show");
              if (mainHeader) mainHeader.classList.remove("hide-for-sticky");
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Index Toggle Logic (Supports both Reports and Blogs)
  $(document).on("click", ".index-trigger", function (e) {
    if (window.location.href.includes("industry-analysis")) return;
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const targetAttr = this.getAttribute("href");
    let allowToggle = true;

    if (targetAttr && !targetAttr.includes("javascript")) {
      try {
        const targetUrl = new URL(this.href);
        const targetPath = targetUrl.pathname.replace(/\/$/, "");
        if (currentPath !== targetPath) {
          allowToggle = false;
        }
      } catch (err) { }
    }

    if (allowToggle) {
      e.preventDefault();
      e.stopPropagation();

      if (typeof updateUrlToReport === "function") {
        updateUrlToReport();
      }

      const accordionItem = $(this).closest(
        ".accordion-item, .sidebar-section",
      );
      const wrap = accordionItem.find(".index-collapse-inner");

      if (wrap.length) {
        wrap.slideToggle();
        $(this).toggleClass("active");
        accordionItem.toggleClass("active");
        $(this).find(".icon-chevron").toggleClass("rotate");
      }

      // Switch to Description pane to show content on the right
      const descTabLink = document.querySelector('.report-tab-nav a[href="#home"]');
      if (descTabLink && !descTabLink.parentElement.classList.contains("active")) {
        // Trigger Bootstrap tab switch or manual click
        $(descTabLink).tab("show");
        descTabLink.click();
      }
    }
  });

  // Auto-expand index when scrolling (Desktop Only)
  let sidebarWasSticky = false;
  let indexTicking = false;
  window.addEventListener("scroll", function () {
    if (!indexTicking) {
      window.requestAnimationFrame(function () {
        const sidebar = $(
          ".report-detail-sidebar, .blog-detail-sidebar, .listing-sidebar",
        );
        if (sidebar.length && window.innerWidth > 1024) {
          const currentTrigger = sidebar.find(".index-trigger");
          const currentWrap = sidebar.find(".index-collapse-inner");

          if (currentTrigger.length && currentWrap.length) {
            try {
              const scrollThreshold = 200;
              const scrollPos = $(window).scrollTop();
              const indexList = document.querySelector(".index-h2-list, .article-nav");
              const chevron = currentTrigger.find(".icon-chevron");

              // Visibility check for the whole widget based on content
              if (!indexList || !indexList.children.length) {
                if (chevron.length) chevron.hide();
                // If it's a blog and we are sticky, maybe we want to hide it, 
                // but let's be careful not to hide manually opened ones at the top.
                if (scrollPos > scrollThreshold) {
                  currentWrap.hide();
                }
              } else {
                if (chevron.length) chevron.show();
              }

              if (scrollPos > scrollThreshold) {
                if (!sidebarWasSticky) {
                  if (!currentWrap.is(":visible")) {
                    currentWrap.slideDown(400);
                  }
                  currentTrigger.addClass("active");
                  currentTrigger.closest(".accordion-item, .sidebar-section").addClass("active");
                  sidebarWasSticky = true;
                }
              } else if (scrollPos <= 50) {
                if (sidebarWasSticky) {
                  if (currentWrap.is(":visible")) {
                    currentWrap.slideUp(400);
                  }
                  currentTrigger.removeClass("active");
                  currentTrigger.closest(".accordion-item, .sidebar-section").removeClass("active");
                  sidebarWasSticky = false;
                }
              }
            } catch (err) {
              console.error("Index scroll error:", err);
            }
          }
        }
        indexTicking = false;
      });
      indexTicking = true;
    }
  }, { passive: true });

  // Global Per Page Select
  $(document).on("change", ".perPageSelectBtn", function () {
    var perPage = $(this).val();
    var context = $(this).data("context") || "";
    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "set_per_page",
      type: "POST",
      data: {
        per_page: perPage,
        context: context,
        _: new Date().getTime(),
      },
      success: function () {
        window.location.reload();
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error: " + status + " - " + error);
      },
    });
  });

  // --- Global Scroll To Top ---
  const scrollToTopBtn = document.getElementById("scrollToTop");
  if (scrollToTopBtn) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        scrollToTopBtn.classList.add("active");
      } else {
        scrollToTopBtn.classList.remove("active");
      }
    });

    scrollToTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  // --- Hard Refresh on Back Navigation (Ensures Form Reset) ---
  $(window).on("pageshow", function (event) {
    var isBackNavigation = false;

    // 1. Check if the page is loaded from the bfcache (Back-Forward Cache)
    if (event.originalEvent && event.originalEvent.persisted) {
      isBackNavigation = true;
    }
    // 2. Check Modern Navigation Timing API
    else if (window.performance && window.performance.getEntriesByType) {
      var navEntries = window.performance.getEntriesByType("navigation");
      if (navEntries.length > 0 && navEntries[0].type === "back_forward") {
        isBackNavigation = true;
      }
    }
    // 3. Fallback for older browsers
    else if (
      window.performance &&
      window.performance.navigation &&
      window.performance.navigation.type === 2
    ) {
      isBackNavigation = true;
    }

    if (isBackNavigation) {
      window.location.reload();
    }
  });
});

// ==========================================
// Moved from header.php for Optimization
// ==========================================

// --- Analytics, GTM, and Turnstile ---


// --- Turnstile & Modal Lazy Loading ---
(function () {
  var turnstileLoaded = false;

  // Global function to load Turnstile on demand
  window.loadTurnstile = function (callback) {
    if (window.turnstile) {
      if (typeof callback === 'function') callback();
      return;
    }
    if (turnstileLoaded) return;
    turnstileLoaded = true;

    var script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = function () {
      // Render any existing turnstiles on the page
      document.querySelectorAll('.cf-turnstile:not([data-initialized])').forEach(function (el) {
        if (window.turnstile) {
          try {
            turnstile.render(el, {
              callback: window.turnstileCallback || null
            });
            el.setAttribute('data-initialized', 'true');
          } catch (e) { console.warn("Auto-render failed", e); }
        }
      });
      if (typeof callback === 'function') callback();
    };
    document.head.appendChild(script);
  };

  // Global Modal Manager
  window.PMR_Modal = {
    ensureLoaded: function (modalId, templateId) {
      if (document.getElementById(modalId)) return true;
      var template = document.getElementById(templateId);
      if (!template) return false;

      var clone = template.content.cloneNode(true);
      document.body.appendChild(clone);
      return true;
    },

    initTurnstile: function (containerId) {
      window.loadTurnstile(function () {
        // If no containerId passed, search for common ones
        var targets = containerId ? [containerId] : ['modal-turnstile-container', 'pr-modal-turnstile', 'blog-modal-turnstile', 'turnstile-container'];

        targets.forEach(function (id) {
          var container = document.getElementById(id);
          if (container && window.turnstile && !container.getAttribute('data-initialized')) {
            try {
              turnstile.render('#' + id, {
                callback: window.turnstileCallback || null
              });
              container.setAttribute('data-initialized', 'true');
            } catch (e) {
              console.warn("Turnstile render failed for " + id, e);
            }
          }
        });
      });
    }
  };

  // Load Turnstile on first interaction if not already triggered
  ['focusin', 'click', 'mousemove', 'touchstart', 'scroll'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      window.loadTurnstile();
    }, { once: true, passive: true });
  });
})();

// --- Search functionality ---
$(document).ready(function () {
  // Desktop Header Search Suggestions
  $("#searchTxtHeader").keyup(function () {
    var searchTxt = $(this).val();
    if (searchTxt.length >= 3) {
      $.ajax({
        type: "GET",
        url: window.PMR_SETTINGS.baseUrl + "HomeController/autoSearchResult",
        dataType: "JSON",
        data: { 'searchTxt': searchTxt },
        success: function (data) {
          $("#suggesstion-box-header").empty();
          if (data.length > 0) {
            $.each(data, function (i, item) {
              var url = item.url.replace(/ /g, "-");
              $("#suggesstion-box-header").show();
              $("#suggesstion-box-header").append("<p><a href='" + url + "' target='_blank'>" + item.title + "</a></p>");
            });
          } else {
            $("#suggesstion-box-header").hide();
          }
        }
      });
    }
    if (searchTxt.length < 3) {
      $("#suggesstion-box-header").empty().hide();
    }
  });

  $(document).mouseup(function (e) {
    var container = $("#suggesstion-box-header, #searchTxtHeader");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("#suggesstion-box-header").hide();
    }
  });

  // Handle Global Search Submit
  $("#search-form-header, #search-form, #search-form-hero, #search-form-industries").submit(function (e) {
    e.preventDefault();
    var searchInput = $(this).find('input[name="searchTxt"]');
    var searchTxt = searchInput.val();
    if (searchTxt && searchTxt.trim() !== '') {
      var url = window.PMR_SETTINGS.baseUrl + "search-result/" + searchTxt.trim().replace(/\s+/g, '-').split('/').map(encodeURIComponent).join('/');
      window.location.href = url;
    } else {
      window.location.href = window.PMR_SETTINGS.baseUrl + "search-result/";
    }
    return false;
  });

  // Mobile Search Suggestions
  $("#searchTxt").keyup(function () {
    var searchTxt = $(this).val();
    if (searchTxt.length >= 3) {
      $.ajax({
        type: "GET",
        url: window.PMR_SETTINGS.baseUrl + "HomeController/autoSearchResult",
        dataType: "JSON",
        data: { 'searchTxt': searchTxt },
        success: function (data) {
          $("#suggesstion-box").empty();
          $.each(data, function (i, item) {
            var url = item.url.replace(/ /g, "-");
            $("#suggesstion-box").show();
            $("#suggesstion-box").append("<p><a href='" + url + "' target='_blank'>" + item.title + "</a></p>");
          });
        }
      });
    }
    if (searchTxt.length < 3) {
      $("#suggesstion-box").empty().hide();
    }
  });

  $(document).mouseup(function (e) {
    var container = $("#suggesstion-box, #searchTxt");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("#suggesstion-box").hide();
    }
  });

  $(document).on('click', '.search-toggle-mob', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.main-header .search-box').addClass('active');
    $('body').addClass('no-scroll search-open');
    setTimeout(() => {
      $('#searchTxt').focus().click();
    }, 300);
  });

  $(document).on('click', '#mobileSearchClose', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.main-header .search-box').removeClass('active');
    $('body').removeClass('no-scroll search-open');
    $("#suggesstion-box").hide();
  });
});

function getSearchResult() {
  var searchTxt = $("#searchTxt").val();
  if (searchTxt != '') {
    $('#exampleModal').modal('show');
    $.ajax({
      type: "POST",
      url: window.PMR_SETTINGS.baseUrl + "HomeController/getSearchResult/",
      dataType: "JSON",
      data: { 'searchTxt': searchTxt },
      success: function (data) {
        $("#report_all").empty();
        $("#press_all").empty();
        $("#blog_all").empty();
        $.each(data.report_all, function (i, item) {
          var url = item.report_url.replace(/ /g, "-");
          $("#report_all").append("<p><a href='" + window.PMR_SETTINGS.baseUrl + "industry-analysis/" + url + "' target='_blank'>" + item.heading + "</a></p>");
        });
        $.each(data.press_all, function (i, item) {
          var url = item.url.replace(/ /g, "-");
          $("#press_all").append("<p><a href='" + window.PMR_SETTINGS.baseUrl + "press-releases/" + url + "' target='_blank'>" + item.title + "</a></p>");
        });
        $.each(data.blog_all, function (i, item) {
          var url = item.url.replace(/ /g, "-");
          $("#blog_all").append("<p><a href='" + window.PMR_SETTINGS.baseUrl + "blog/" + url + "' target='_blank'>" + item.title + "</a></p>");
        });
      }
    });
  }
}

function searchResult() {
  var searchTxt = $("#searchTxt").val();
  if (searchTxt != '') {
    var url = window.PMR_SETTINGS.baseUrl + "search-result/" + searchTxt.trim().replace(/\s+/g, '-').split('/').map(encodeURIComponent).join('/');
    window.open(url, '_blank');
  }
}

function handleSearchSubmit() {
  var searchTxt = $("#searchTxt").val();
  if (searchTxt && searchTxt.trim() !== '') {
    var url = window.PMR_SETTINGS.baseUrl + "search-result/" + searchTxt.trim().replace(/\s+/g, '-').split('/').map(encodeURIComponent).join('/');
    window.location.href = url;
  } else {
    window.location.href = window.PMR_SETTINGS.baseUrl + "search-result/";
  }
  return false;
}

// --- Tawk.to Widget Lazy Load ---
(function () {
  var tawkLoaded = false;
  function loadTawk() {
    if (tawkLoaded) return;
    tawkLoaded = true;
    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/5f02d16d223d045fcb7b5fb2/1jmkm3vv8';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);

    ['focusin', 'mousemove', 'touchstart', 'scroll'].forEach(function (ev) {
      document.removeEventListener(ev, loadTawk);
    });
  }
  if (window.PMR_SETTINGS && window.PMR_SETTINGS.env === 'Production') {
    ['focusin', 'mousemove', 'touchstart', 'scroll'].forEach(function (ev) {
      document.addEventListener(ev, loadTawk, { once: true, passive: true });
    });
  }
})();

// --- Cookie Popup Logic ---
$(document).ready(function () {
  const cookiePopup = document.getElementById('cookiePopup');
  const closeBtn = document.getElementById('closeCookiePopup');
  const cookieName = 'pmr_cookies_consent';

  function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  if (!getCookie(cookieName)) {
    setTimeout(() => {
      if (cookiePopup) cookiePopup.style.display = 'block';
    }, 2500);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (cookiePopup) cookiePopup.style.display = 'none';
      setCookie(cookieName, 'accepted', 24);
    });
  }
});

// --- Unified Sidebar Drawer Logic ---
$(document).ready(function () {
  // Unified overlay closer
  $(document).on('click', '#sidebar-overlay, .sidebar-overlay', function () {
    $('body').removeClass('sidebar-open search-open menu-open no-scroll');
    $('.search-box, .report-sidebar, .mobile-toggle').removeClass('active');
  });

  // Mobile Menu Toggle
  const toggle = document.querySelector('.mobile-toggle');
  const nav = document.querySelector('.main-header__nav');
  const body = document.querySelector('body');
  const drawerTriggers = document.querySelectorAll('.drawer-trigger');
  const sidebar = document.querySelector('.report-sidebar');
  const closeSidebar = document.querySelector('.close-sidebar');

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (window.innerWidth < 992) {
        // On mobile, open Unified Sidebar starting with drawer-main
        document.querySelectorAll('.drawer-section').forEach(sec => {
          sec.classList.remove('active');
          sec.style.display = (sec.id === 'drawer-main') ? 'block' : 'none';
        });
        sidebar.classList.add('active');
        body.classList.add('sidebar-open');
      } else {
        this.classList.toggle('active');
        nav.classList.toggle('active');
        body.classList.toggle('menu-open');
      }
    });
  }

  // Handle Drawer Triggers (Reports, Services, etc.)
  drawerTriggers.forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetSection = document.getElementById(targetId);

      if (window.innerWidth < 992) {
        // Stack animations for mobile
        if (targetSection) {
          targetSection.style.display = 'block';
          // Use a timeout to allow display:block to take effect before adding the active class for transition
          setTimeout(() => {
            targetSection.classList.add('active');
          }, 10);
        }
      } else {
        // Desktop behavior
        document.querySelectorAll('.drawer-section').forEach(sec => sec.style.display = 'none');
        if (targetSection) targetSection.style.display = 'block';
        sidebar.classList.add('active');
        body.classList.add('sidebar-open');
      }
    });
  });

  // Close Sidebar
  if (closeSidebar) {
    closeSidebar.addEventListener('click', function () {
      sidebar.classList.remove('active');
      body.classList.remove('sidebar-open');
      // Reset all levels
      setTimeout(() => {
        document.querySelectorAll('.drawer-section').forEach(sec => sec.classList.remove('active'));
        document.querySelectorAll('.sidebar-submenu').forEach(sub => sub.classList.remove('active'));
      }, 400);
    });
  }

  // Mobile Drill-down for Level 3 Submenus (Industries)
  // Exposed as window.PMR_initHasChild so the AJAX nav loader can re-run it
  // after dynamically injecting category items.
  const sidebarInner = document.querySelector('.sidebar-inner');
  var _pmrDrillIdx = 0;

  window.PMR_initHasChild = function (scope) {
    var container = scope || document;
    var links = container.querySelectorAll('.has-child > a:not([data-pmr-target])');
    links.forEach(function (link) {
      var subId = 'pmr-drill-' + (_pmrDrillIdx++);
      var nestedSub = link.parentNode.querySelector('.sidebar-submenu');
      if (nestedSub) {
        nestedSub.setAttribute('data-pmr-id', subId);
        link.setAttribute('data-pmr-target', subId);
      }

      link.addEventListener('click', function (e) {
        if (window.innerWidth < 992) {
          e.preventDefault();
          var sid = this.getAttribute('data-pmr-target');
          var submenu = sidebarInner ? sidebarInner.querySelector('[data-pmr-id="' + sid + '"]') : null;
          if (submenu && sidebarInner) {
            if (submenu.parentNode !== sidebarInner) {
              sidebarInner.appendChild(submenu);
            }
            setTimeout(function () {
              submenu.classList.add('active');
            }, 20);
          }
        }
      });
    });
  };

  // Run immediately for statically rendered items
  window.PMR_initHasChild();

  // Inject Back Buttons for ALL nested levels
  function injectBackButtons() {
    document.querySelectorAll('.drawer-section:not(#drawer-main)').forEach(sec => {
      if (!sec.querySelector('.mobile-back-btn')) {
        const backBtn = document.createElement('div');
        backBtn.className = 'mobile-back-btn';
        backBtn.innerHTML = '<i class="fas fa-chevron-left"></i> Back';
        backBtn.onclick = function () {
          sec.classList.remove('active');
          setTimeout(() => {
            sec.style.display = 'none';
          }, 400);
        };
        sec.insertBefore(backBtn, sec.firstChild);
      }
    });

    document.querySelectorAll('.sidebar-submenu').forEach(sub => {
      if (!sub.querySelector('.mobile-back-btn')) {
        const backBtn = document.createElement('div');
        backBtn.className = 'mobile-back-btn';
        backBtn.innerHTML = '<i class="fas fa-chevron-left"></i> Back';
        backBtn.onclick = function () {
          sub.classList.remove('active');
        };
        sub.insertBefore(backBtn, sub.firstChild);
      }
    });
  }
  injectBackButtons();
});

